import { InputHTMLAttributes, useRef } from "react";
import "./input.scss";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  placeholder: string;
  type?: string;
  value: any;
  setValue?: any;
  list?: any;
  required?: boolean;
  className?: string;
  disabled?: boolean;
  errorMessage?: string;
  errorStatus?: boolean;
  autofocus?: boolean;
  pattern?: string;
  asterisk?: boolean;
  onBlur?: any;
  maxLength?: number;
}

function Input({
  name,
  label,
  placeholder,
  value,
  setValue,
  type,
  required,
  className,
  disabled,
  errorStatus,
  errorMessage,
  autofocus,
  list,
  pattern,
  asterisk = true,
  onBlur,
  maxLength,
  ...rest
}: InputProps) {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    setValue(event);
  }

  return (
    <div className={`input-component ${className} ${errorStatus && "pb-8"}`}>
      <label className="input-component__label">
        {label}
        {required && asterisk ? <span className="text-red-500"> *</span> : ""}
      </label>
      <input
        className={`input-component__default
        ${disabled ? "input-component__disabled" : ""}
        ${errorStatus ? "border-2 border-red-500" : "border-2 border-gray-300"}`}
        list={list}
        name={name}
        disabled={disabled || false}
        required={required || false}
        type={type || "text"}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        autoFocus={autofocus}
        pattern={pattern}
        onBlur={onBlur}
        maxLength={maxLength}
        {...rest}
      />
      {errorStatus && <span className={`input-component__errorMessage`}>{errorMessage}</span>}
    </div>
  );
}

export default Input;
